import { IOrderSale } from '../../order-sale-form';
import { ValidationError } from 'yup';

export function areKilosAvailable(
    value: any,
    context: any,
): boolean | ValidationError {
    const { kilos, product } = context.from[0]
        .value as IOrderSale['order_sale_products'][number];

    const orderSale = context.from[1].value as IOrderSale;
    const orderRequestRemainingProducts =
        orderSale.order_request?.order_request_remaining_products || [];

    const remainingProduct = orderRequestRemainingProducts.find((rProduct) => {
        return rProduct.product_id === product?.id;
    });

    if (!remainingProduct) return true;
    if (!(remainingProduct.kilos - kilos >= 0)) {
        return context.createError({
            message: `La cantidad de kilos sobrepasa la disponible (kilos disponibles: ${remainingProduct.kilos})`,
        });
    }

    return true;
}
